<template>
  <div class="content-item module-pagination">
    <div class="pagination__button pagination__button--prev" :class="{ '-disabled': currentPage === 1 }" @click="currentPage !== 1 ? changeCurrentPage(currentPage - 1) : ''"><span>{{ $t('list.pagination.back') }}</span></div>

    <div class="pagination__list">
      <div class="pagination__button" v-if="startPage >= 2" @click="changeCurrentPage(1)"><span>1</span></div>
      <div class="pagination__button pagination__button--placeholder" v-if="startPage >= 3"><span>...</span></div>
      <div class="pagination__button" v-for="page in pages" :class="{ '-active': currentPage === page }" :key="'page-' + page" @click="changeCurrentPage(page)"><span>{{ page }}</span></div>
      <div class="pagination__button pagination__button--placeholder" v-if="startPage + showButtons - 1 < totalPages - 1"><span>...</span></div>
      <div class="pagination__button" v-if="startPage + showButtons - 1 < totalPages" @click="changeCurrentPage(totalPages)"><span>{{ totalPages }}</span></div>
    </div>

    <div class="pagination__button pagination__button--next" :class="{ '-disabled': currentPage === totalPages }" @click="currentPage !== totalPages ? changeCurrentPage(currentPage + 1) : ''"><span>{{ $t('list.pagination.next') }}</span></div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'

const props = defineProps({
  currentPage: {
    type: Number,
    default: 1
  },
  recordsPerPage: {
    type: Number,
    default: 10
  },
  totalRecords: {
    type: Number,
    default: 0
  },
  showButtons: {
    type: Number,
    default: 3
  }
})

const emit = defineEmits(['change-current-page'])

const totalPages = computed(() => {
  return Math.ceil(props.totalRecords / props.recordsPerPage)
})

const startPage = computed(() => {
  // When on the first page or less pages then buttons to show
  if (props.currentPage === 1 || totalPages.value <= props.showButtons) {
    return 1
  }
  // When on the last page or showButtons pages before last page
  if (props.currentPage === totalPages.value || props.currentPage + props.showButtons - 1 >= totalPages.value) {
    return totalPages.value - props.showButtons + 1
  }
  // When in between
  return props.currentPage - Math.floor(props.showButtons / 2) > 1 ? props.currentPage - Math.floor(props.showButtons / 2) : 1
})

const pages = computed(() => {
  let range = []

  for (let i = startPage.value; i <= Math.min(startPage.value + props.showButtons - 1, totalPages.value); i += 1) {
    range.push(i)
  }

  return range
})

function changeCurrentPage (page) {
  emit('change-current-page', page)
}
</script>

